import { combineReducers, Reducer } from 'redux';
import authReducer from './AuthReducer';
import configReducer from './ConfigReducer';

const rootReducer = combineReducers({
  auth: authReducer as Reducer<Partial<{ isAuthenticated: boolean; token: any; profile: any; forgotPassword: any }>>,
  config: configReducer as Reducer<Partial<{ customerServiceUrl: string }>>,
});

export default rootReducer;